import type { Organization } from '~publish/legacy/organizations/types'
import type { Profile } from '~publish/legacy/profile-sidebar/types'

export type GenerateProfileTabsInput = {
  profile?: Partial<Profile>
  organization?: Pick<Organization, 'hasGridFeature' | 'hasStoriesFeature'>
}

const generateProfileTabs = ({
  profile,
  organization,
}: GenerateProfileTabsInput): string[] => {
  const { hasGridFeature, hasStoriesFeature } = organization || {}
  const { service } = profile || {}
  const isInstagramChannel = service === 'instagram'

  const tabsList = ['queue', 'sentPosts', 'settings', 'approvals', 'drafts']
  if (isInstagramChannel) {
    tabsList.push('pastReminders')
  }
  if (hasGridFeature && isInstagramChannel) {
    tabsList.push('grid')
  }
  if (hasStoriesFeature && isInstagramChannel) {
    tabsList.push('stories')
  }

  return tabsList
}

export default generateProfileTabs
